// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Container, ContainerProps } from "@hardwoods/App/Components/Container/Container";
import { mergeWithCss } from "@hardwoods/XDL/Utilities/mergeWithCss";
import Zone from "@insite/client-framework/Components/Zone";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page, { PageProps } from "@insite/mobius/Page";
import React, { FC } from "react";

interface Props {
    id: string;
    showBreadcrumbs?: boolean;
    extendedStyles?: CustomLayoutStyle;
}

export interface CustomLayoutStyle {
    headerContainer?: PageProps;
    breadcrumbContainer?: PageProps;
    mainContainer?: PageProps;
}

const customLayoutStyle: CustomLayoutStyle = {};

export const CustomLayout: FC<Props> = ({ id, showBreadcrumbs, extendedStyles }) => {
    const [styles] = React.useState(() => mergeWithCss(customLayoutStyle, extendedStyles));

    return (
        <>
            <Page as="div" {...styles.headerContainer}>
                <Zone contentId={id} zoneName="Content0" />
            </Page>
            {showBreadcrumbs && (
                <Page as="div" {...styles.breadcrumbContainer}>
                    <PageBreadcrumbs />
                </Page>
            )}
            <Page as="div" {...styles.mainContainer}>
                <Zone contentId={id} zoneName="Content1" />
            </Page>
        </>
    );
};

CustomLayout.defaultProps = {
    showBreadcrumbs: true,
};

export default CustomLayout;
